import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabSix() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > 24x7 SUPPORT & MAINTANACE </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            It's important to maintain the performance of your CCTV cameras so that you will achieve a safe and secure space for you and your precious assets and property. We provide exceptional maintenance services in Hyderabad to improve the work of the security systems.
                        </p>
                        <p className='service_des_p'>
                            We offer complete protection to your staff, property, visitors, and many more by cleaning the lenses and checking all the functions of the CCTV cameras. We are equipped with advanced devices and professional experts who meet all your standard needs to solve the complications related to your CCTV technical problems and many more.
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> Your Security That We Maintain  </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'>Whatever the problem in your security system, our experts are ready to alleviate it in no time at an affordable price.Regardless of the problem in your security system, our specialists are ready to alleviate it in no time at an affordable price.  </p>
                        <ul>
                            <li> 24x7 Staff Services</li>
                            <li> Find Potential Solutions</li>
                        </ul>
                        <p className='service_des_p'>We are always available to provide security solutions to make you feel safe and secure. Royality Technologies thrives to give customers satisfactory experience and quality service.</p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabSix